import { createApp } from "vue";
import App from "./App.vue";

import "vuetify/styles/main.css";
import "@/styles/typography-overrides.scss";

// Styles
import "@/styles/main.scss";

// Router
import router from "./router/index";

// Pinia
import { createPinia, setActivePinia } from "pinia";

// Vuetify
import { vuetify } from "./vuetify/vuetify";

// Head
import { createHead } from "@unhead/vue/client";

import { useAuthStore } from "./store/auth.store";
import { useGeneralStore } from "./store/general.store";
import { Stopwatch } from "./shared/utils/waiters";
import { isValidAuthData, logUserIn } from "./services/auth.service";

const VUE_APP = createApp(App);

const pinia = createPinia();
setActivePinia(pinia);

const head = createHead();

VUE_APP.use(pinia);
VUE_APP.use(head);
VUE_APP.use(router);
VUE_APP.use(vuetify);

async function appBoot() {
    const SW = new Stopwatch();

    const AUTH_STORE = useAuthStore();
    const GENERAL_STORE = useGeneralStore();

    if (AUTH_STORE.auth_data) {
        if (isValidAuthData(AUTH_STORE.auth_data)) {
            try {
                await logUserIn(AUTH_STORE.auth_data, true);
            } catch (err) {
                console.error(err);
            }
        } else {
            AUTH_STORE.unsetAuthState();
        }
    }
    await SW.waitUntil(222);
    GENERAL_STORE.setAppBooted(true);
}

await appBoot();

VUE_APP.mount("#app");
